import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginPage from '../views/LoginPage.vue'
import MainPage from '../views/MainPage.vue'
import ErrorsPage from '../views/ErrorsPage.vue'

Vue.use(VueRouter)

const routes = [
  {
    path:'/',
    component:LoginPage
  },
  {
    path:'/main',
    component:MainPage
  },
  {
    path:'*',
    component:ErrorsPage
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router